<div class="image-gallery-container mt-6" *ngIf="!isReportType()" [ngClass]="{ 'full-height2': images.length <= 2 }">
  <div class="main-image">
    <div *ngIf="showStreetView == false">
      <img [src]="mainImage" alt="Main Property Image" />
      <div class="street-btn">
        <button class="street-view-btn" (click)="showMap()"><mat-icon> map</mat-icon>Map</button>
      </div>
    </div>
    <div *ngIf="showStreetView == true">
      <app-street-view [defaultPlace]="setStreetViewEvent" class="street-view"></app-street-view>
    </div>
  </div>
  <div
    class="image-grid"
    *ngIf="displayImages.length != 0"
    [ngClass]="{ 'full-height': displayImages.length === 3, 'full-height1': displayImages.length === 2 }"
  >
    <ng-container *ngFor="let img of displayImages; let i = index">
      <div class="image-item">
        <img [src]="img" alt="Property Image" (click)="openGallery(i)" />
      </div>
    </ng-container>
  </div>
  <div class="more-images-container" *ngIf="remainingImagesCount > 0">
    <button class="more-btn" (click)="openGallery(remainingImagesCount)">
      <mat-icon> image</mat-icon>{{ remainingImagesCount }} Photos
    </button>
    <!-- <div class="overlay" (click)="openGallery(remainingImagesCount)">+{{ remainingImagesCount }} Photos</div> -->
  </div>
</div>

<div [ngClass]="'full-height2'" *ngIf="isReportType() && showBirdEye == true">
  <app-street-view
    [defaultPlace]="defaultPlace"
    class="street-view"
    (streetViewAvailable)="onStreetViewAvailable($event)"
  ></app-street-view>
</div>
<div [ngClass]="'full-height2'" *ngIf="isReportType() && showBirdEye == false">
  <app-birds-eye-view [defaultPlace]="defaultPlace"></app-birds-eye-view>
</div>

<div class="row mt-4">
  <div class="col-md-12">
    <mat-card class="property-card preview-section">
      <div class="card-head">
        <!-- Title & Subtitle on the Left -->
        <div class="mat-card-group">
          <mat-card-title class="address" (click)="openPropertyDetails(propertyDetails)"
            >{{ propertyDetails?.reportName }}
            <span
              *ngIf="propertyDetails?.clientType != 'seller'"
              class="property-badge sale-type mt-2"
              [ngClass]="getStatusClass(propertyDetailsResponse?.StandardStatus)"
            >
              {{ propertyDetailsResponse?.StandardStatus }}
            </span>
          </mat-card-title>
          <mat-card-subtitle class="sub-title" *ngIf="propertyDetails?.reportCategory != 'smartReport'">
            Received on: <b>{{ propertyDetails?.createdDate | date }}</b> | Customer:
            <b>{{ propertyDetails?.clientName }}</b>
          </mat-card-subtitle>
        </div>

        <!-- Buttons on the Right -->
        <div class="button-container">
          <button mat-flat-button class="start-value" color="primary" (click)="moveToValuation()">
            {{
              propertyDetails?.reportCategory == 'smartReport'
                ? propertyDetails?.cmaReportData?.selectedValueType == 'CUSTOM_VALUE'
                  ? 'Your Value'
                  : propertyDetails?.cmaReportData?.selectedValueType == 'SALES_COMPARISON_VALUE'
                  ? 'Model Adjusted Value'
                  : 'Starting Value'
                : 'Home Value'
            }}<br />
            <strong
              >$
              {{
                propertyDetails?.compReportData?.valueReport?.homeValue?.selectedValue
                  ? (propertyDetails.compReportData.valueReport.homeValue?.selectedValue | number)
                  : propertyDetails?.compReportData?.valueReport?.homeValue?.avm?.value
                  ? (propertyDetails.compReportData.valueReport.homeValue.avm.value | number)
                  : '--'
              }}</strong
            >
          </button>
          <button
            mat-flat-button
            color="primary"
            class="start-value"
            *ngIf="propertyDetails?.reportCategory != 'smartReport'"
            (click)="moveToValuation()"
          >
            Net Seller Proceeds<br />
            <strong
              >$
              {{
                propertyDetails?.compReportData?.valueReport?.netProceeds?.netProceeds
                  ? (propertyDetails.compReportData.valueReport.netProceeds.netProceeds | number)
                  : '--'
              }}</strong
            >
          </button>
        </div>
      </div>

      <mat-card-content>
        <ul class="prop_highlight pl-0 mb-0">
          <li [matTooltip]="'Bed'">
            <img src="../../assets/images/bed.svg" width="24" />
            <p class="inline-block ipad_amn_break ml-1">
              <b>{{ propertyDetailsResponse?.BedroomsTotal ? propertyDetailsResponse?.BedroomsTotal : '--' }}</b>
            </p>
          </li>
          <li [matTooltip]="'Bath'">
            <img src="../../assets/images/bath.svg" width="24" />
            <p class="inline-block ipad_amn_break ml-1">
              <b>{{ propertyDetails?.baths }}</b>
            </p>
          </li>
          <li [matTooltip]="'Living Area'">
            <img src="../../assets/images/living_area.svg" width="24" />
            <p class="inline-block ipad_amn_break ml-1">
              <b>{{ propertyDetails?.livingArea }}</b> <small> sq.ft</small>
            </p>
          </li>
          <li [matTooltip]="'Lot Size Square Feet'">
            <img src="../../assets/images/land_area.svg" width="24" />
            <p class="inline-block ipad_amn_break ml-1">
              <b>{{ propertyDetails?.lotSize }}</b> <small> sq.ft</small>
            </p>
          </li>
        </ul>
        <div
          class="co-branded-section"
          *ngIf="
            propertyDetails?.compReportData?.valueReport?.agent?.fullName ||
            propertyDetails?.compReportData?.valueReport?.loanOfficer?.fullName
          "
        >
          <div class="co-branded-label">
            <img src="~/../assets/images/co-branding.svg" alt="Co-Branded" class="icon" />
            <span>Brought to you by :</span>
          </div>
          <div class="co-branded-info">
            <div class="agent" *ngIf="propertyDetails?.compReportData?.valueReport?.agent?.fullName">
              <img
                [src]="propertyDetails.compReportData.valueReport.agent.photoUrl || defaultProfileImage"
                alt="User"
                class="user-icon"
              />
              <div class="agent-details">
                <strong>{{ propertyDetails.compReportData.valueReport.agent.fullName || '--' }} (Broker)</strong>
                <p>
                  Direct: {{ propertyDetails.compReportData.valueReport.agent.phone || '--' }} | E:
                  {{ propertyDetails.compReportData.valueReport.agent.email || '--' }}
                </p>
              </div>
            </div>
            <div class="agent" *ngIf="propertyDetails?.compReportData?.valueReport?.loanOfficer?.fullName">
              <img
                [src]="propertyDetails.compReportData.valueReport.loanOfficer.photoUrl || defaultProfileImage"
                alt="User"
                class="user-icon"
              />
              <div class="agent-details">
                <strong
                  >{{ propertyDetails.compReportData.valueReport.loanOfficer.fullName || '--' }} (Loan Officer)</strong
                >
                <p>
                  Direct: {{ propertyDetails.compReportData.valueReport.loanOfficer.phone || '--' }} | E:
                  {{ propertyDetails.compReportData.valueReport.loanOfficer.email || '--' }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div class="row mt-4">
  <div class="col-md-12">
    <mat-card class="property-card preview-section">
      <!-- Title & Subtitle on the Left -->
      <div class="mat-card-group">
        <mat-card-title class="card-heading">About Property</mat-card-title>
      </div>

      <mat-card-content>
        <div class="row mb-4">
          <div class="col-md-12" *ngIf="propertyDetails?.clientType != 'seller'">
            <div class="about-property">
              {{
                isExpanded
                  ? propertyDetailsResponse?.PublicRemarks
                  : (propertyDetailsResponse?.PublicRemarks | slice: 0:500)
              }}
              <span *ngIf="!isExpanded && propertyDetailsResponse?.PublicRemarks?.length > 500">...</span>
            </div>
            <a
              class="show-more"
              *ngIf="propertyDetailsResponse?.PublicRemarks?.length > 500"
              (click)="toggleShowMore()"
            >
              {{ isExpanded ? 'Show Less' : 'Show More' }}
            </a>
          </div>
          <a></a>
        </div>
        <div class="row">
          <div class="col-lg-4 col-sm-6 col-6 mb-4">
            <h4 class="mb-2">
              {{ propertyDetailsResponse?.ArchitecturalStyle ? propertyDetailsResponse.ArchitecturalStyle : '--' }}
            </h4>
            <span>Architectural Style</span>
          </div>
          <div class="col-lg-4 col-sm-6 col-6 mb-4">
            <h4 class="mb-2">
              {{
                propertyDetailsResponse?.ConstructionMaterials ? propertyDetailsResponse.ConstructionMaterials : '--'
              }}
            </h4>
            <span>Construction</span>
          </div>
          <div class="col-lg-4 col-sm-6 col-6 mb-4">
            <h4 class="mb-2">{{ propertyDetailsResponse?.YearBuilt ? propertyDetailsResponse.YearBuilt : '--' }}</h4>
            <span>Year Built</span>
          </div>
          <div *ngIf="propertyDetails?.clientType != 'seller'" class="col-lg-4 col-sm-6 col-6 mb-4">
            <h4 class="mb-2">
              {{
                propertyDetailsResponse?.ListingContractDate
                  ? (propertyDetailsResponse.ListingContractDate | date)
                  : '--'
              }}
            </h4>
            <span>Listed On</span>
          </div>
          <div *ngIf="propertyDetails?.clientType != 'seller'" class="col-lg-4 col-sm-6 col-6 mb-4">
            <h4 class="mb-2">
              {{ propertyDetailsResponse?.DaysOnMarket ? propertyDetailsResponse.DaysOnMarket : '--' }}
            </h4>
            <span>Days on Market</span>
          </div>
          <div *ngIf="propertyDetails?.clientType != 'seller'" class="col-lg-4 col-sm-6 col-6 mb-4">
            <h4 class="mb-2">
              {{
                propertyDetailsResponse?.ListPrice
                  ? (propertyDetailsResponse.ListPrice | currency: 'USD':'symbol':'1.0-0')
                  : '--'
              }}
            </h4>
            <span>List Price</span>
          </div>
          <div class="col-lg-4 col-sm-6 col-6 mb-4">
            <h4 class="mb-2">
              {{
                propertyDetailsResponse?.AssociationFee
                  ? '$' +
                    (propertyDetailsResponse.AssociationFee * 1 | number) +
                    '/' +
                    propertyDetailsResponse.AssociationFeeFrequency
                  : '--'
              }}
            </h4>
            <span>Association Fee</span>
          </div>
          <div class="col-lg-4 col-sm-6 col-6 mb-4">
            <h4 class="mb-2">
              {{
                propertyDetailsResponse?.ParkingSpaces && propertyDetailsResponse.ParkingSpaces != '0'
                  ? propertyDetailsResponse.ParkingSpaces
                  : '--'
              }}
            </h4>
            <span>Parking Total</span>
          </div>
          <div class="col-lg-4 col-sm-6 col-6 mb-4">
            <h4 class="mb-2">
              {{
                propertyDetailsResponse?.GarageSpaces ? (propertyDetailsResponse.GarageSpaces | number: '1.0-0') : '--'
              }}
            </h4>
            <span>Garage Spaces</span>
          </div>
          <div class="col-lg-4 col-sm-6 col-6 mb-4">
            <h4 class="mb-2">
              {{ formatYesNo(propertyDetailsResponse?.PoolPrivateYN) }}
            </h4>
            <span>Pool</span>
          </div>
          <div class="col-lg-4 col-sm-6 col-6 mb-4">
            <h4 class="mb-2">{{ propertyDetailsResponse?.Stories ? propertyDetailsResponse.Stories : '--' }}</h4>
            <span>Stories</span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h4 class="my-3 headWrap">Interior Features</h4>
            <div class="row">
              <ul class="pl-0 w-50" style="padding-right: 10px">
                <li class="Interior-ul">
                  <div class="property">Rooms:</div>
                  <ul>
                    <li>
                      Bedrooms:
                      <span>
                        {{ propertyDetailsResponse?.BedroomsTotal ? propertyDetailsResponse?.BedroomsTotal : '--' }}
                      </span>
                    </li>
                    <li>
                      Full Bathrooms:

                      <span> {{ propertyDetailsResponse?.BathroomsDecimal | number: '1.0-0' }} </span>
                    </li>
                    <li>
                      Half Bathrooms:
                      <span>
                        {{ propertyDetailsResponse?.BathroomsFull ? propertyDetailsResponse?.BathroomsFull : '--' }}
                      </span>
                    </li>
                    <li>
                      Total Rooms:
                      <span>
                        {{ propertyDetailsResponse?.BathsFull ? propertyDetailsResponse?.BathsFull : '--' }}
                      </span>
                    </li>
                  </ul>
                </li>
                <li class="Interior-ul">
                  <div class="property">Fireplaces:</div>
                  <ul>
                    <li class="ng-star-inserted">
                      Number of Fireplaces:
                      <span>{{
                        propertyDetailsResponse?.FireplacesTotal ? propertyDetailsResponse.FireplacesTotal : '--'
                      }}</span>
                    </li>
                    <li>
                      Fireplace Features:
                      <span>{{
                        propertyDetailsResponse?.FireplaceFeatures ? propertyDetailsResponse.FireplaceFeatures : '--'
                      }}</span>
                    </li>
                  </ul>
                </li>
                <li class="Interior-ul">
                  <div class="property">Area:</div>
                  <ul>
                    <li>
                      Building Area:
                      <span>
                        {{ propertyDetailsResponse?.LivingArea ? propertyDetailsResponse.LivingArea + ' sq.ft' : '--' }}
                      </span>
                    </li>
                    <li>
                      Garage Area:
                      <span>{{
                        propertyDetailsResponse?.GarageArea
                          ? propertyDetailsResponse.GarageArea
                          : propertyDetailsResponse?.GarageSpaces
                          ? (propertyDetailsResponse.GarageSpaces | number: '1.0-0')
                          : '--'
                      }}</span>
                    </li>
                  </ul>
                </li>
                <li class="Interior-ul">
                  <div class="property">Basement:</div>
                  <ul>
                    <li>
                      Finished Area:
                      <span>
                        {{
                          propertyDetailsResponse?.BelowGradeTotalArea
                            ? propertyDetailsResponse.BelowGradeTotalArea + ' sq.ft'
                            : '--'
                        }}
                      </span>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul class="pl-0 w-50 other-details" style="padding-right: 10px">
                <li class="ng-star-inserted">
                  <div>Appliances:</div>
                  <div class="interior-detail">{{ propertyDetailsResponse?.Appliances || '--' }}</div>
                </li>
                <li>
                  <div>Interior Features:</div>
                  <div class="interior-detail">{{ propertyDetailsResponse?.InteriorFeatures || '--' }}</div>
                </li>
                <li>
                  <div>Heating:</div>
                  <div class="interior-detail">{{ propertyDetailsResponse?.Heating || '--' }}</div>
                </li>
                <li>
                  <div>Cooling:</div>
                  <div class="interior-detail">{{ propertyDetailsResponse?.Cooling || '--' }}</div>
                </li>
                <li>
                  <div>Flooring:</div>
                  <div class="interior-detail">{{ propertyDetailsResponse?.Flooring || '--' }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <h4 class="my-3 headWrap">Exterior Features</h4>
            <ul class="pl-0 w-100 prop_char" style="padding-right: 10px">
              <li>
                <div>Roof Description:</div>

                <div class="interior-detail">
                  {{
                    propertyDetailsResponse?.Roof ||
                      (propertyDetailsResponse?.RoofType && propertyDetailsResponse?.RoofCoverType
                        ? propertyDetailsResponse?.RoofType + ',' + propertyDetailsResponse?.RoofCoverType
                        : propertyDetailsResponse?.RoofType || propertyDetailsResponse?.RoofCoverType || '--')
                  }}
                </div>
              </li>
              <li>
                <div>Patio &amp; Porch Features:</div>
                <div class="interior-detail">{{ propertyDetailsResponse?.PatioAndPorchFeatures || '--' }}</div>
              </li>
              <li>
                <div>Pool Features:</div>
                <div class="interior-detail">
                  {{ formatYesNo(propertyDetailsResponse?.PoolFeatures) || propertyDetailsResponse?.PoolType || '--' }}
                </div>
              </li>
              <li>
                <div>Pool Private YN:</div>
                <div>
                  {{ formatYesNo(propertyDetailsResponse?.PoolPrivateYN) }}
                </div>
              </li>
              <li>
                <div>Exterior Features:</div>
                <div class="interior-detail">{{ propertyDetailsResponse?.ExteriorFeatures || '--' }}</div>
              </li>
            </ul>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<app-image-gallery
  *ngIf="isGalleryOpen"
  [selectedIndex]="imageGalleryState.imgGalleryCurrentIndex"
  (close)="closeGallery()"
  [isImagesFullView]="true"
></app-image-gallery>

<ng-template #mapDialog>
  <h2 mat-dialog-title>Map View</h2>

  <mat-dialog-content>
    <ng-container class="img-fluid mx-auto property-image p-md-3">
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-md-12 mb-3">
          <mat-radio-group [(ngModel)]="selectedMapView" (change)="onViewChange($event)">
            <mat-radio-button value="streetView">Street View</mat-radio-button>
            <mat-radio-button class="pl-2" value="birdsEyeView">Bird's Eye View</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12" [hidden]="isStreetView">
          <app-birds-eye-view class="street-view" [defaultPlace]="setBirdsEyeViewEvent"></app-birds-eye-view>
        </div>
        <div class="col-lg-12" [hidden]="!isStreetView">
          <app-street-view class="street-view" [defaultPlace]="setStreetViewEvent"></app-street-view>
        </div>
      </div>
    </ng-container>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button (click)="closeDialog()">Close</button>
  </mat-dialog-actions>
</ng-template>
